module.exports = __webpack_public_path__ + "img/slide-asset-3.9ac7e569.png";